// 4993 — Flex hours gating in the PWA (WIT-IMPL-FLEX-4993-001).
//
// The tenant flag arrives from the timer API only (/settings/app →
// generalSettings.flex_hours, resolved server-side from the tenant record,
// D-FLEX-3 / D-FLEX-8). The PWA never computes it and never trusts a stored
// copy: absent or anything but `true` means legacy, so every flex screen stays
// hidden for a tenant that has not been opted in (fail closed).
//
// Entries carry their own mode (D-FLEX-4): an existing entry is a flex entry
// only when the API says `mode: 'flex'`, whatever the tenant flag says today;
// a new entry follows the tenant flag.

export function flexHoursFromSettings (settings) {
  return Boolean(settings && settings.flex_hours === true)
}

export function isFlexEntry (entry, tenantFlexEnabled) {
  if (entry && entry.id) return entry.mode === 'flex'
  return Boolean(tenantFlexEnabled)
}
